import { useCallback, useEffect, useRef, useState } from 'react';
import FJInput from '../common/FJInput/FJInput';
import FJButton from '../common/FJButton/FJButton';
import Style from './LoginBrick.module.less';
import FJLocalStore from '../../store/FJLocalStore';
import FJNav from '../common/FJNav/FJNav';
import classNames from 'classnames';
import FJCaptcha from '../common/FJCaptcha/FJCaptcha';
import FJErrTip from '../common/FJErrTip/FJErrTip';
import useLocalStore from '../../hooks/useLocalStore';
import FJUtil from '../../util/FJUtil';

const LoginBrick = props => {
    useLocalStore();
    let { email, emailLogin, stepChange, forgetClick, active, popupType, passwordSeeLogin, changePasswordSeeLogin } =
        props;
    const [password, setPassword] = useState('');
    const [load, setLoad] = useState(false);
    const [errTip, setErrTip] = useState(null);
    let inputRef = useRef();
    let passwordChange = curValue => {
        _clean();
        setPassword(curValue);
    };
    let _clean = () => {
        inputRef.current.setInit();
        setErrTip(null);
    };
    let _navClick = () => {
        stepChange('default');
    };

    let _formatCheck = useCallback(() => {
        let res = true;
        if (password.length === 0) {
            inputRef.current.setErrorMessage(FJLocalStore._('enter-password-here'));
            res = false;
            return res;
        } else {
            inputRef.current.setInit();
        }
        return res;
    }, [password]);
    let _login = useCallback(() => {
        let res = _formatCheck();
        if (!res) {
            return;
        }
        setLoad(true);
        emailLogin(password, option => {
            setLoad(false);
            if (option.networkFail) {
                setErrTip(option.errTip);
            } else if (option.result === true) {
                setErrTip(null);
            } else {
                setErrTip(option.errTip);
            }
        });
    }, [password, _formatCheck, emailLogin]);

    let _enterLogin = useCallback(
        event => {
            if (event.keyCode === 13) {
                _login();
            }
        },
        [_login],
    );

    useEffect(() => {
        FJUtil.addEvent(window, 'keydown', _enterLogin);
        return () => {
            FJUtil.removeEvent(window, 'keydown', _enterLogin);
        };
    }, [_enterLogin]);

    return (
        <div
            id='loginBox'
            className={classNames(Style.login_box, {
                [Style.login_box_show]: active,
                [Style.login_box_popup]: popupType,
            })}
        >
            <FJNav title={FJLocalStore._('login')} onClick={_navClick} popupType={popupType} />
            {/* 此处添加input为特殊处理 谷歌自动填充 */}
            <div style={{ userSelect: 'none' }}>
                <input defaultValue={email} autoComplete='UserName' type='text' style={{ width: '1px', opacity: 0 }} />
                <input type='text' style={{ width: '1px', height: '54px', opacity: 0 }} />
            </div>
            <p
                className={Style.curTip}
                dangerouslySetInnerHTML={{ __html: FJLocalStore._('login-to-enter-password').replace('xxx', email) }}
            />
            <FJInput
                value={password}
                onChange={passwordChange}
                label={FJLocalStore._('password')}
                placeholder={FJLocalStore._('enter-password-here')}
                type='password'
                className={Style.inputMargin}
                inputClassName={Style.input}
                iconClassName={Style.inputRightIcon}
                forgetClick={forgetClick}
                ref={inputRef}
                inputCanSee={passwordSeeLogin}
                changeInputCanSee={changePasswordSeeLogin}
                popupType={popupType}
                hasRightIcon
                forgetTip
                dataAutoId='Password-Input'
            />
            <FJErrTip errTip={errTip} />
            <FJButton
                text={FJLocalStore._('login')}
                small={popupType}
                className={Style.login_btn}
                isLoading={load}
                onClick={_login}
                dataAutoId='Logo-Button'
            />
            <div
                className='g-recaptcha'
                style={{ display: 'flex', justifyContent: 'center', padding: '20px 0 0 0' }}
                id='login-recaptcha'
            />
        </div>
    );
};
export default LoginBrick;
